// Phase 6 cost landing pages — every number on them comes from the backend's daily price cache.
import { imgProps } from "./images";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/cost`;
const pending = new Map();

// One in-flight promise per path so the boot-time preload (App.preloadRoute) and the page's own fetch share a request;
// results stay cached for a minute so client-side navigation back to a page is instant but admin edits show up soon after.
function get(path) {
  if (pending.has(path)) return pending.get(path);
  const p = fetch(`${API}${path}`).then(async (r) => {
    const data = await r.json().catch(() => ({}));
    if (!r.ok) { const e = new Error(data?.detail || "Request failed"); e.status = r.status; throw e; }
    return data;
  });
  p.then(() => setTimeout(() => pending.delete(path), 60_000), () => pending.delete(path));
  pending.set(path, p);
  return p;
}

const typePath = (slug) => `/type/${encodeURIComponent(slug)}`;
const pagePath = (type, metro, preview = "") => `/page/${encodeURIComponent(type)}/${encodeURIComponent(metro)}${preview ? `?preview=${encodeURIComponent(preview)}` : ""}`;

export const fetchCostHub = () => get("/hub").catch(() => ({ types: [], metros: [], published: 0 }));
export const fetchCostHubStrict = () => get("/hub");
export const fetchCostType = (slug) => get(typePath(slug));
export const fetchCostPage = (type, metro, preview = "") => get(pagePath(type, metro, preview));
export const fetchCostMatch = (zip, type) => get(`/match?zip=${encodeURIComponent(zip)}&type=${encodeURIComponent(type)}`).catch(() => ({ path: null }));

// Boot-time: start the page's data request alongside the route chunk and preload its hero (the LCP image) as soon as we know it.
export function preloadCost(pathname, search = "") {
  const parts = pathname.split("/").filter(Boolean);
  if (parts[0] !== "cost") return null;
  if (parts.length === 1) return fetchCostHub();
  if (parts.length === 2) return fetchCostType(parts[1]).catch(() => null);
  const preview = new URLSearchParams(search).get("preview") || "";
  return fetchCostPage(parts[1], parts[2], preview).then((d) => {
    const img = imgProps(d.metro?.hero_image, "100vw");
    if (!img.src || document.querySelector(`link[rel="preload"][href="${img.src}"]`)) return d;
    const link = Object.assign(document.createElement("link"), { rel: "preload", as: "image", href: img.src, fetchPriority: "high" });
    if (img.srcSet) { link.setAttribute("imagesrcset", img.srcSet); link.setAttribute("imagesizes", img.sizes); }
    document.head.appendChild(link);
    return d;
  }).catch(() => null);
}

export const metroShort = (m) => (m?.display_name || "").replace(/\s*\(.*\)\s*$/, "");
export const costTitle = (type, metro, year) => `${type.display_name} Cost in ${metro.display_name}, ${metro.state} (${year}) | ID Builder Construction`;
export const usd = (n) => `$${Math.round(n).toLocaleString("en-US")}`;
